import { FC, useState } from 'react';
import IframeStyledHOC from './IframeStyledHOC';
import { IframeStyled, Loader, Logo, Root, Spinner } from './style';
import { Props } from './types';

const Iframe: FC<Props> = ({ src, logoSrc, useModernPlayer, ...rest }) => {
  const [loading, setLoading] = useState<boolean>(true);

  const hideSpinner = () => {
    setLoading(false);
  };

  return (
    <Root>
      {loading && (
        <Loader>
          <Spinner />
          <Logo>
            <img src={logoSrc} alt="" />
          </Logo>
        </Loader>
      )}
      {useModernPlayer ? (
        <IframeStyledHOC width="100%" height="100%" src={src} onLoad={hideSpinner} {...rest} />
      ) : (
        <IframeStyled width="100%" height="100%" src={src} allow="geolocation;camera;microphone" onLoad={hideSpinner} {...rest} />
      )}
    </Root>
  );
};

export default Iframe;
